import type { TradeInAemSettingsType } from "../reducers/TradeInAemSettingsReducer";

export const TRADE_IN_AEM_SETTINGS_INIT = "tradeInAemSettings/init";
type TradeInAemSettingsInit = { type: typeof TRADE_IN_AEM_SETTINGS_INIT; initState: TradeInAemSettingsType };
export const initTradeInAemSettings = (initState: TradeInAemSettingsType): TradeInAemSettingsInit => ({
    type: TRADE_IN_AEM_SETTINGS_INIT,
    initState,
});

export type TradeInAemSettingsActionsType = TradeInAemSettingsInit;
